import { Permission } from '@/lib/permissions/v1'
import { formParamKey } from '@/composables/route'

export enum FormsRouteName {
    Index = 'forms.index',
    Clone = 'forms.clone',
    Create = 'forms.create',
    Edit = 'forms.edit',
    Show = 'forms.show',
}

export default {
    path: '/forms',
    name: FormsRouteName.Index,
    component: () => import('@/views/forms/Layout.vue'),
    children: [
        {
            path: '',
            name: FormsRouteName.Index,
            component: () => import('@/views/forms/Index.vue'),
            meta: {
                label: 'Forms',
                auth: true,
                permission: Permission.FormViewAny,
            },
        },
        {
            path: 'create',
            name: FormsRouteName.Create,
            component: () => import('@/views/forms/Create.vue'),
            meta: {
                label: 'Create Form',
                auth: true,
                permission: Permission.FormCreate,
            },
        },
        {
            path: `:${formParamKey}/edit`,
            name: FormsRouteName.Edit,
            component: () => import('@/views/forms/Edit.vue'),
            meta: {
                label: 'Edit Form',
                auth: true,
                permission: Permission.FormUpdate,
            },
        },
        {
            path: `:${formParamKey}/clone`,
            name: FormsRouteName.Clone,
            component: () => import('@/views/forms/Clone.vue'),
            meta: {
                label: 'Create Form',
                auth: true,
                permission: Permission.FormCreate,
            },
        },
    ],
}
